import { combineReducers } from '@reduxjs/toolkit'
import {AuthReducer} from './auth/auth';
import {NotifierReducer} from './notifier/notifier';
import {EnterprisesReducer,ProductsReducer} from './enterprises/enterprise';
import {BackdropReducer} from './backdrop/backdrop'
import { reportsAttendanceReducer } from "../store/attendance/attendance";
import {ReportReducer} from "../store/report/report"
import { DepartmentReducer } from "../store/departments/departments";
export const rootReducer = combineReducers({
    auth:AuthReducer,
    notifier:NotifierReducer,
    backdrop:BackdropReducer,
    enterprises:EnterprisesReducer,
    products:ProductsReducer,
    attendance: reportsAttendanceReducer,
    reports:ReportReducer,
    departments: DepartmentReducer
})

export type RootState = ReturnType<any>

export default rootReducer
